/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormStateBuilder } from '@gh/common-shared';
import { isSelectionModelEmpty, SelectionModel, SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { STYLES_FLEX_COLUMN_LAYOUT } from '@gh/core-ui';
import { GridDefinition, GridDefinitionFactory } from '@gh/core-ui-grid';
import { SchedulesSupervisorPrintMode, ScheduleSupervisorReportTask } from '../../../resources/schedule-list.model';

@Component({
  selector: 'gh-schedule-supervisors-report-filter-supplier-step',
  template: require('./schedule-supervisors-report-filter-supplier-step.component.html'),
  styles: [STYLES_FLEX_COLUMN_LAYOUT],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleSupervisorsReportFilterSupplierStepComponent implements OnInit {
  @Input() selectionModel: SelectionModel;
  @Input() dataSource: SlicedDataSource<ScheduleSupervisorReportTask>;
  @Input() printMode: SchedulesSupervisorPrintMode;

  @Output() selectionModelChange = new EventEmitter<SelectionModel>();
  @Output() taskExistChange = new EventEmitter<boolean>();
  @Output() printModeChange = new EventEmitter<SchedulesSupervisorPrintMode>();
  @Output() showSupplierList = new EventEmitter<void>();

  gridDefinition: GridDefinition;

  constructor(private translations: TranslationService,
              private formStateBuilder: FormStateBuilder,
              private gridDefinitionFactory: GridDefinitionFactory) {
  }

  get isSelectionEmpty(): boolean {
    return isSelectionModelEmpty(this.selectionModel);
  }

  ngOnInit(): void {
    this.gridDefinition = this.gridDefinitionFactory.buildManual(
      [
        { field: 'parentName', headerName: this.translations.get('lbl_task'), width: 200 },
        { field: 'name', headerName: this.translations.get('lbl_description'), width: 400 },
      ],
      {
        getRowNodeId: (task) => task.scheduleTaskId,
        defaultColDef: {
          sortable: false,
        },
      });
  }
}
